
import DataErrorPage from '../../../../../Components/DataErrorPage/DataErrorPage';

const ReadonlyPlaceholderPage: React.FC<React.PropsWithChildren<{}>> = () => {
  return <DataErrorPage errorText="Rutinen saknar stöd för läsbehörighet" />;
};

export default ReadonlyPlaceholderPage;
